const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const formatFaultDate = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 180, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 180, flex: 1 },
  { field: "tempCondensacionEntrada", headerName: "Temp. Condensación Entrada", minWidth: 200, flex: 1 },
  { field: "tempCondensacionSalida", headerName: "Temp. Condensación Salida", minWidth: 200, flex: 1 },
  { field: "tempDescargaCompresor", headerName: "Temp. Descarga Compresor", minWidth: 200, flex: 1 },
  { field: "tempRefrEvaporado", headerName: "Temp. Refr Evaporado", minWidth: 200, flex: 1 },
  { field: "presionSuccion", headerName: "Presión Succión", minWidth: 150, flex: 1 },
  { field: "presionDescarga", headerName: "Presión Descarga", minWidth: 150, flex: 1 },
  { field: "voltajeCmp", headerName: "Voltaje Cmp", minWidth: 150, flex: 1 },
  { field: "amperajeCmp", headerName: "Amperaje Cmp", minWidth: 150, flex: 1 },
  { field: "sobrecalentamiento", headerName: "Sobrecalentamiento", minWidth: 150, flex: 1 },
  { field: "condicionActual", headerName: "Condicion Actual", minWidth: 200, flex: 1 },
  { field: "porcentajeCarga", headerName: "Porcentaje de Carga", minWidth: 200, flex: 1 },
  { field: "controlCarga", headerName: "Control de Carga", minWidth: 200, flex: 1 },
  { field: "ramploading", headerName: "Ramploading", minWidth: 200, flex: 1 },
  { field: "switchFlujoAguaCondensacion", headerName: "Switch Flujo Agua Condensación", minWidth: 200, flex: 1 },
  { field: "switchFlujoAguaHelada", headerName: "Switch Flujo Agua Helada", minWidth: 200, flex: 1 },
  { field: "bajoNivelAceiteComp", headerName: "Bajo Nivel Aceite Compresor", minWidth: 200, flex: 1 },
  { field: "statusTempMotor", headerName: "Status Temp Motor", minWidth: 200, flex: 1 },
  { field: "interlock", headerName: "Interlock", minWidth: 200, flex: 1 },
  { field: "statusMotorProtect", headerName: "Status MotorProtect", minWidth: 200, flex: 1 },
  { field: "arranqueRemoto", headerName: "Arranque Remoto", minWidth: 200, flex: 1 },
  { field: "paroEmergencia", headerName: "Paro de Emergencia", minWidth: 200, flex: 1 },
  { field: "encendidoCompresor", headerName: "Encendido Compresor", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvula1", headerName: "Load/Unload Válvula 1", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvula2", headerName: "Load/Unload Válvula 2", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvula3", headerName: "Load/Unload Válvula 3", minWidth: 200, flex: 1 },
  { field: "solenoideGasCaliente", headerName: "Solenoide de Gas Caliente", minWidth: 200, flex: 1 },
  { field: "inyeccionLiquidoSuccion", headerName: "Inyección Líquido Succión", minWidth: 200, flex: 1 },
  { field: "tiempoServicioHoras", headerName: "Tiempo de Servicio en Horas", minWidth: 200, flex: 1 },
  { field: "horasTotalesOperacion", headerName: "Horas Totales de Operación", minWidth: 200, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 200, flex: 1 },
  { field: "numeroFalla1", headerName: "Número de Falla 1", minWidth: 300, flex: 1 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 200, flex: 1 },
  { field: "numeroFalla2", headerName: "Número de Falla 2", minWidth: 300, flex: 1 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 200, flex: 1 },
  { field: "numeroFalla3", headerName: "Número de Falla 3", minWidth: 300, flex: 1 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 200, flex: 1 },
  { field: "numeroFalla4", headerName: "Número de Falla 4", minWidth: 300, flex: 1 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 200, flex: 1 },
  { field: "numeroFalla5", headerName: "Número de Falla 5", minWidth: 300, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempProcesoEntrada: row["Temp. Proceso Entrada"],
  tempProcesoSalida: row["Temp. Proceso Salida"],
  tempCondensacionEntrada: row["Temp. Condensación Entrada"],
  tempCondensacionSalida: row["Temp. Condensación Salida"],
  tempDescargaCompresor: row["Temp. Descarga Compresor"],
  tempRefrEvaporado: row["Temp. Refr Evaporado"],
  presionSuccion: row["Presion Succion"],
  presionDescarga: row["Presion Descarga"],
  voltajeCmp: row["Voltaje Cmp"],
  amperajeCmp: row["Amperaje Cmp"],
  sobrecalentamiento: row["Sobrecalentamiento"],
  condicionActual: row["Condicion Actual"],
  porcentajeCarga: row["Porcentaje Carga"],
  controlCarga: row["Control de Carga"],
  ramploading: row["Ramploading"],
  switchFlujoAguaCondensacion: row["Switch Flujo Agua Condensacion"],
  switchFlujoAguaHelada: row["Switch Flujo Agual Helada"],
  bajoNivelAceiteComp: row["Bajo Nivel Aceite Comp"],
  statusTempMotor: row["Status Temp Motor"],
  interlock: row["Interlock"],
  statusMotorProtect: row["Status MotorProtect"],
  arranqueRemoto: row["Arranque Remoto"],
  paroEmergencia: row["Paro de Emergencia"],
  encendidoCompresor: row["Encendido Compresor"],
  loadUnloadValvula1: row["Load/Unload Valvula 1 Comp. 1"],
  loadUnloadValvula2: row["Load/Unload Valvula 2 Comp. 1"],
  loadUnloadValvula3: row["Load/Unload Valvula 3 Comp. 1"],
  solenoideGasCaliente: row["Solenoide de Gas Caliente"],
  inyeccionLiquidoSuccion: row["Inyección de Líquido en la Succión"],
  tiempoServicioHoras: row["Tiempo de Servicio en Horas"],
  horasTotalesOperacion: row["Horas Totales de Operación"],
  fechaFalla1: formatFaultDate(row["Fecha de Falla 1"]),
  numeroFalla1: row["Numero de Falla 1"],
  fechaFalla2: formatFaultDate(row["Fecha de Falla 2"]),
  numeroFalla2: row["Numero de Falla 2"],
  fechaFalla3: formatFaultDate(row["Fecha de Falla 3"]),
  numeroFalla3: row["Numero de Falla 3"],
  fechaFalla4: formatFaultDate(row["Fecha de Falla 4"]),
  numeroFalla4: row["Numero de Falla 4"],
  fechaFalla5: formatFaultDate(row["Fecha de Falla 5"]),
  numeroFalla5: row["Numero de Falla 5"],
});

export const licuador1CompConsultaConfig = {
  title: "Licuador 1 Comp",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/licuador1comp/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "Licuador 1Comp",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};